import React from 'react';
import { SWRConfig } from 'swr';
var BASE_URL = 'https://icanhazdadjoke.com';

var fetcher = function fetcher(endpoint) {
  return fetch(BASE_URL + endpoint, {
    headers: {
      Accept: 'application/json'
    }
  }).then(function (res) {
    return res.json();
  });
};

var SWRProvider = function SWRProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(SWRConfig, {
    value: {
      fetcher: fetcher,
      revalidateOnFocus: false
    }
  }, children);
};

export default SWRProvider;